import React, { useState, useEffect, useRef, useMemo, useCallback} from 'react';
import { useNavigate } from 'react-router-dom';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { AddOutline, MinusOutline, EyeOutline, EyeInvisibleOutline } from 'antd-mobile-icons';
import { Button } from 'antd-mobile';
import { setWechatTitle } from '../../utils/wechatTitle';
import { useWechatShare } from '../../utils/wechatShare';
import './HomePage.css';
import { BannerModel } from '../../models/bannerModel';
import { CategoryModel } from '../../models/categoryModel';
import BannerCarousel from './BannerCarousel'
import FloatingButtons from './FloatingButtons'


const HomePage = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const [banners, setBanners] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [imageContainerHeight, setImageContainerHeight] = useState('0px');
  const bannerRef = useRef(null); // 轮播图容器引用
  const footerRef = useRef(null); // 备案footer容器引用
  const transformRef = useRef(null);
  // 背景图URL
  const bigImageUrl = useMemo(() => `${window.location.origin}/images/home_bg_new.png`, []);
  // const bigImageUrl = useMemo(() => `https://resources.eos-dongguan-1.cmecloud.cn/agri/home_bg_new.png`, []);
  
  // 按钮背景色
  const buttonColors = useMemo(() => [
    '#e15759', '#4e79a7', '#f28e2c', '#76b7b2', '#59a14f', '#af7aa1', '#edc949', '#ff9da7','#d9bb4c', '#00BCD4',
  ], []);

  // 特色按钮配置
  const teseButton = useMemo(() => ({
    id: 'teseby',
    name: '特色',
    icon: `${window.location.origin}/images/tese_icon.png`,
    color: '#e15759'
  }), []);
  
  // 获取轮播图数据
  useEffect(() => {

    // 预加载大图
    const preloadImages = async () => {
      const img = new Image();
      img.src = bigImageUrl;
      await new Promise(resolve => {
        img.onload = resolve;
        img.onerror = resolve;
      });
    };
    // 获取分类数据
    const fetchCategories = async () => {
      try {
        const data = await CategoryModel.getCategories({homeShow: 'SHOW'});
        setCategories(data);
      } catch (error) {
        console.error('获取分类数据失败:', error);
        setCategories([]);
      }
    };
    // 获取轮播图数据
    const fetchBanners = async () => {
      try {
        setLoading(true);
        const data = await BannerModel.getBannerList();
        setBanners(data);
      } catch (error) {
        console.error('获取轮播图数据失败:', error);
        setBanners([]);
      } finally {
        setLoading(false);
      }
    };

    preloadImages();
    fetchCategories();
    fetchBanners();
  }, [bigImageUrl]);

  // 动态计算高度（屏幕高度 - 轮播图高度）
  useEffect(() => {
    // 计算高度的函数
    const calculateHeight = () => {
      const screenHeight = window.innerHeight; // 屏幕高度
      const bannerHeight = bannerRef.current?.offsetHeight || 0; // 轮播图实际高度
      const footerHeight = footerRef.current?.offsetHeight || 0; // 备案栏高度
      const targetHeight = screenHeight - bannerHeight - footerHeight; // 目标高度
      console.log("screenHeight==>",screenHeight)
      console.log("bannerHeight==>",bannerHeight)
      console.log("targetHeight==>",targetHeight)
      setImageContainerHeight(`${targetHeight}px`); // 设置为大图容器高度
    };

    // 初始化计算
    calculateHeight();
    // 窗口大小变化时重新计算（适配窗口 resize）
    window.addEventListener('resize', calculateHeight);
    // 组件卸载时移除监听
    return () => window.removeEventListener('resize', calculateHeight);
  }, [banners]); 

  // 缩放控制方法
  const handleZoomIn = useCallback(() => {
    transformRef.current?.zoomIn(0.2);
  }, []);

  const handleZoomOut = useCallback(() => {
    transformRef.current?.zoomOut(0.2);
  }, []);

  // const handleReset = () => {
  //   transformRef.current?.resetTransform();
  // };


  // 轮播点击处理
  const handleBannerClick = useCallback((banner) => {
    console.log('轮播图点击：', banner);
    if (banner.relationType === 'ROUTE') {
      navigate(`/route/detail/${banner.routeId}?bannerId=${banner.id}`);
    } else if (banner.relationType === 'CONTENT') {
      navigate(`/detail/${banner.contentId}`);
    }
  }, [navigate]);

  // 微信分享
  // const shareImgUrl = useMemo(() => `${window.location.origin}/images/banner1.jpg`, []);
  useWechatShare(
    '珠海旅游指南',
    '发现珠海的美好之处，民宿、餐饮、采摘等应有尽有',
    ''
  );

  // 按钮点击逻辑
  const handleButtonClick = useCallback((item) => {
    if (item.id === 'teseby') {
      navigate('/specialties');
    } else {
      navigate(`/list?category=${item.id}`, { state: { fromListPage: false } });
    }
  }, [navigate]);
  // 合并按钮列表
  const allButtons = useMemo(() => [teseButton, ...categories], [categories, teseButton]);
  
  // 缓存悬浮按钮属性
  const floatingButtonsProps = useMemo(() => ({
    visible,
    buttons: allButtons,
    buttonColors,
    onButtonClick: handleButtonClick
  }), [visible, allButtons, buttonColors, handleButtonClick]);

  // 设置页面标题
  useEffect(() => {
    setWechatTitle("汇华博雅珠海乡村旅游地图");
  }, []);


  return (
    <div className="app-container" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f9fafb' }}>
      {/* Banner轮播 */}
      {/* <div className="banner-container" ref={bannerRef}> */}
        {loading ? (
          <div className="banner-loadding-container">
            <div className="loading-spinner"></div>
          </div>
        ) : banners.length > 0 ? (
          <BannerCarousel 
            banners={banners} 
            onBannerClick={handleBannerClick} 
            className="banner-container" ref={bannerRef}
          />
        ) : (<></>)}
      {/* </div> */}

      {/* 大图区域（调大初始显示尺寸） */}
      <div className={`image-container bg-f2f2f2`}
        style={{ 
          height: imageContainerHeight, // 关键：动态高度
          minHeight: 0 // 避免 flex 布局冲突
        }}
      >
        <TransformWrapper
          ref={transformRef}
          initialScale={1.5} // 初始缩放比例调大（默认1 → 1.2，放大20%）2.3
          minScale={1.2}    // 最小缩放也适当调大（避免缩得太小）
          maxScale={2}      // 最大缩放保持不变 3
          limitToBounds={true}
          // centerOnInit      // 保持初始居中
        >
          <TransformComponent>
            {/* 大图：通过基础样式进一步放大初始尺寸 */}
            <img
              src={bigImageUrl}
              alt="首页地图"
              className="large-image"
              style={{
                width: '100%', // 基础宽度调大（默认100% → 110%）
                maxWidth: 'none' // 确保不受父容器宽度限制
              }}
              onError={(e) => {
                console.error('背景图加载失败！路径：', bigImageUrl);
                // e.target.alt = '背景图加载失败';
              }}
            />
          </TransformComponent>
        </TransformWrapper>
        <div className="right-button-group">
        <Button 
          shape="circle" 
          size="large" 
          className="eye-button group-button first-button"
          onClick={() => setVisible(prev => !prev)}
        >
          {!visible ? <EyeInvisibleOutline /> : <EyeOutline />}
        </Button>
        <Button 
          size="large" 
          className="eye-button group-button middle-button"
          onClick={handleZoomIn}
        >
          <AddOutline />
        </Button>
        <Button 
          size="large" 
          className="eye-button group-button last-button"
          onClick={handleZoomOut}
        >
          <MinusOutline />
        </Button>
        </div>
        {/* 悬浮按钮组 */}
        <FloatingButtons {...floatingButtonsProps} />
      </div>

      {/* 备案信息 */}
      <div className="icp-footer" ref={footerRef}>
        <a
          className="icp-link"
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          粤ICP备2026002081号
        </a>
      </div>
    </div>
  );

};
export default HomePage;